export const getEnvironmentVariables = () => {
  return { ...window.__env__ };
};
